import { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./PropertyCard.css";

const FALLBACKS = {
  "Villa":      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=700&q=80",
  "Studio":     "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=700&q=80",
  "Commercial": "https://images.unsplash.com/photo-1497366216548-37526070297c?w=700&q=80",
  "Apartment":  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=700&q=80",
};

export default function PropertyCard({ property }) {
  const imgRef = useRef(null);
  const { t } = useTranslation("common");
  const { slug, title, location, price, priceType, beds, baths, sqft, type, images, reference } = property;

  const photo = (images && images[0]) || FALLBACKS[type] || FALLBACKS["Apartment"];

  const shortLoc = location
    ? location.split(",").slice(0, 2).map(s => s.trim()).join(", ")
    : "";
  const onEnter = () => { if (imgRef.current) imgRef.current.style.transform = "scale(1.03)"; };
  const onLeave = () => { if (imgRef.current) imgRef.current.style.transform = "scale(1)"; };

  return (
    <Link to={`/property/${slug}`} className="pcard" onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <div className="pcard-img">
        <img
          ref={imgRef}
          src={photo}
          alt={title}
          loading="lazy"
          style={{ transition: "transform .7s cubic-bezier(.25,.46,.45,.94)" }}
          onError={e => { e.target.src = FALLBACKS[type] || FALLBACKS["Apartment"]; }}
        />
        <div className="pcard-img-overlay" />
        {!reference && <div className="pcard-watermark" />}
        <span className={`pcard-badge ${priceType === "rent" ? "badge-rent" : "badge-sale"}`}>
          {t(priceType === "rent" ? "badge.rent" : "badge.sale")}
        </span>
        <div className="pcard-hover-btn">{t("btn.viewProp")}</div>
      </div>
      <div className="pcard-body">
        <div className="pcard-price">
          {new Intl.NumberFormat("en-AE").format(price)} AED
          {priceType === "rent" && <span className="pcard-per"> /yr</span>}
        </div>
        <div className="pcard-title">{title}</div>
        <div className="pcard-loc">{shortLoc}</div>
        <div className="pcard-meta">
          <span>{beds > 0 ? `${beds} bed${beds > 1 ? "s" : ""}` : "Studio"}</span>
          <span className="dot-sep">·</span>
          <span>{baths} bath{baths > 1 ? "s" : ""}</span>
          {sqft > 0 && <><span className="dot-sep">·</span><span>{sqft.toLocaleString()} ft²</span></>}
        </div>
      </div>
    </Link>
  );
}
